import { apichatbookInstance, apiInstanceVirtcogateway, apiInstanceVirtcoOrder } from "../../shared-lib/interceptor/interceptor";
import { ApiUrlModel } from "../entities/chatApiUrl-model";
import { MessageModel } from "../entities/chatMessageModel";
import { MessageSummaryDto } from "../entities/chatMsg-summary-dto";
import { BlockUserRequest, ChatSummaryRequest, PinChatRequest, UnBlockUserRequest } from "../types/chat.types";
import ChatApiUrl from "./chat-api-url";
export { addWishList, removeFavorites } from "../../virtco/services/data-provider";

export const GetMessageData = (data: MessageSummaryDto) => {
  const param = new ApiUrlModel("");
  param.id = data.TopicID;
  param.type = data.TopicType;
  param.pageNo = data.PageNo;
  param.pageSize = data.PageSize;
  return apichatbookInstance.get(ChatApiUrl("summaryConversation", param));
};

export const SendMessage = (message: MessageModel) => {
  return apichatbookInstance.post(ChatApiUrl("saveMessage"), message);
};

export const saveChatUser = (user: {
  userId: string;
  userName?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  userAvatar?: string;
  userType?: string;
}) => {
  return apichatbookInstance.post(ChatApiUrl("saveChatUser"), user);
};

export const getUserChatSummary = (body: ChatSummaryRequest) => {
  return apichatbookInstance.post(ChatApiUrl("getUserChatSummary"), body);
};

export const markMsgRead = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apichatbookInstance.post(ChatApiUrl("markMsgRead", param));// new
};
export const getUserBasicInfoByUserId = (data: any) => {
  const param = new ApiUrlModel("");
  param.id = data;
  return apiInstanceVirtcogateway.get(ChatApiUrl("getUserBasicInfoByUserId", param));
};
export const getUsersDetail = (id: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstanceVirtcogateway.get(ChatApiUrl("getUsersDetail", param)); 
};
export const getAllConsultationbyUserId = (data: any) => {
  const param = new ApiUrlModel("");
  param.id = data;
  return apiInstanceVirtcogateway.get(ChatApiUrl("getAllConsultationbyUserId", param));
};
export const getBookingListOfUser = (id: any, body: any) => {
  const param = new ApiUrlModel("");
  param.id = id;
  return apiInstanceVirtcoOrder
    .post(ChatApiUrl("getBookingListOfUser", param), body)
    .then((response: any) => response.data);
};

export const getProjectsChatConsultant = (clientId: string, body: any) => {
  const param = new ApiUrlModel("");
  param.id = clientId;
  return apiInstanceVirtcogateway
    .post(ChatApiUrl("getProjectsChatConsultant", param), body)
    .then((response: any) => response.data);
};

export const getProjectsChatClient = (consultantId: string, body: any) => {
  const param = new ApiUrlModel("");
  param.id = consultantId;
  return apiInstanceVirtcogateway
    .post(ChatApiUrl("getProjectsChatClient", param), body)
    .then((response: any) => response.data);
};

export const pinChat = (body: PinChatRequest) => {
  return apichatbookInstance.post(ChatApiUrl("pinChat"), body);
};

export const unpinChat = (body: PinChatRequest) => {
  return apichatbookInstance.post(ChatApiUrl("unpinChat"), body);
};

export const getBlockReasons = () => {
  return apichatbookInstance.get(ChatApiUrl("blockReasons"));
};

export const blockUser = (body: BlockUserRequest) => {
  return apichatbookInstance.post(ChatApiUrl("blockUser"), body);
};

export const unblockUser = (body: UnBlockUserRequest) => {
  return apichatbookInstance.post(ChatApiUrl("unblockUser"), body);
};

export const getBlockStatus = (recipientId: string) => {
  const param = new ApiUrlModel("");
  param.id = recipientId;
  return apichatbookInstance.get(ChatApiUrl("blockStatus", param));
};

/** Call after SignalR has had time to connect (~2s) so backend does not return false on refresh and then true. */
export const CheckUserIsOnline = (UserId: string) => {
  const param = new ApiUrlModel("");
  param.id = UserId;
  return apichatbookInstance
    .get(ChatApiUrl("checkUserIsOnline", param))
    .then((response: any) => response.data.data);
};
// Import favorite services from main data provider
